export default "__VITE_ASSET__BD9jAUJ5__"